import { render, staticRenderFns } from "./ClientActionButton.vue?vue&type=template&id=23d9bf22"
import script from "./ClientActionButton.vue?vue&type=script&lang=js"
export * from "./ClientActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports